import { DefaultTheme } from 'styled-components';

interface PropsWithTheme {
  theme: DefaultTheme;
}

const FONT_WEIGHT = (fontWeight: keyof DefaultTheme['fontWeights']) => (props: PropsWithTheme) =>
  props.theme.fontWeights[fontWeight];

export const FONT_WEIGHTS = {
  DEFAULT: FONT_WEIGHT('default'),
  SEMI_BOLD: FONT_WEIGHT('semiBold'),
  BOLD: FONT_WEIGHT('bold'),
  HEAVY: FONT_WEIGHT('heavy'),
} as const;
